import React from "react"
import { OneClient } from "../client"
import "./index.scss"

const CasesSays = ({ ceo, data, header, more }) => {
    return (
        <div className={`cases-client ${ceo ? "cases-client-big-image" : ""}`}>
            <h3 className="t-s3">{header}</h3>
            <OneClient
                more={more}
                image={data.image}
                name={data.name}
                desc={data.desc}
                country={data.country}
                clutch={data.clutch}
                link={data.link}
                linkedin={data.linkedin}
                text={data.text}
            />
        </div>
    )
}

export default CasesSays
